import { gql } from '@apollo/client'

export const GET_PAYMENT_SESSION_GQL = gql`
query get_payment_session($price_id: ID!, $force_stripe_portal: Boolean, $return_url: String) {
	payment_session(price_id:$price_id, force_stripe_portal:$force_stripe_portal, return_url:$return_url) {
		id
		customer_portal_url
	}
}`